import React, { useEffect, useRef, useState } from 'react';
import { RAIL_TYPES } from './navData';
import TypeIcon from './TypeIcon';
import TypeMenu from './TypeMenu';
import useCategoryHover from './useCategoryHover';
import { useIsMobile } from '../../utils/useMediaQuery';
import './TypeRail.css';

// Desktop only: a floating pill of category icons fixed to the left edge, with
// each icon's menu pinned beside it. Rendered once by App on every page except
// checkout; mobile uses the hamburger menu instead.
const TypeRail = () => {
    const isMobile = useIsMobile();
    const { openTypeId, close, iconProps, hoverZoneProps } = useCategoryHover();
    const [railHeight, setRailHeight] = useState(null);
    const railRef = useRef(null);

    // Measure the rail so the menu can match its height exactly, no matter how
    // many icons the rail has.
    useEffect(() => {
        const el = railRef.current;
        if (!el) return undefined;
        const measure = () => setRailHeight(el.offsetHeight);
        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(el);
        return () => ro.disconnect();
    }, [isMobile]);

    if (isMobile) return null;

    const openType = RAIL_TYPES.find((t) => t.id === openTypeId) || null;

    return (
        <>
            <nav ref={railRef} className="gh-typerail" aria-label="Browse by category" {...hoverZoneProps}>
                {RAIL_TYPES.map((t) => (
                    <button
                        key={t.id}
                        type="button"
                        className={`gh-typerail-btn ${openTypeId === t.id ? 'active' : ''}`}
                        title={t.label}
                        aria-label={t.label}
                        {...iconProps(t)}
                    >
                        <TypeIcon type={t.id} />
                    </button>
                ))}
            </nav>

            {openType && (
                <TypeMenu type={openType} height={railHeight} onClose={close} {...hoverZoneProps} />
            )}
        </>
    );
};

export default TypeRail;
